import { render, staticRenderFns } from "./DesignRirekishoMyprCard.vue?vue&type=template&id=3b6bbc08"
import script from "./DesignRirekishoMyprCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesignRirekishoMyprCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports